export enum AttendanceScanningType {
  QRCode = 0,
  RFID = 1,
}
